<div class="container collectionContainer">
  <div class="row">
    <div class="col-lg-12 mx-auto">
      <div class="row">
        @if (experts?.length) {
          @for (expert of experts; track expert) {
            <div class="cstmCol overflow-hidden my-3">
              <a
                class="text-dark text-decoration-none collection"
                [routerLink]="'/' + expert.uniqueName"
              >
                <div
                  class="img-container position-relative d-flex justify-content-center align-items-center"
                >
                  <img
                    defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                    [useSrcset]="true"
                    alt="Image"
                    aspect-ratio="1"
                    [lazyLoad]="expert?.profileImage"
                    width="auto"
                    height="auto"
                    class="person"
                  />
                  <div class="top-left">
                    <div class="rating gilroy-m">
                      <img src="assets/images/star.svg" alt="" />
                      {{ expert.rating || 5 }}
                    </div>
                  </div>
                  <div class="username text-white w-100 px-1">
                    <div
                      class="d-flex align-items-center justify-content-start"
                    >
                      <h5
                        class="gilroy-b d-flex text-capitalize mb-0 w-90 wow fadeInDown"
                      >
                        {{ expert?.fullName }}
                      </h5>
                      @if (expert?.isSupportCharity) {
                        <div class="checkBox supportBox oHideBox dCenter">
                          <img
                            width="100%"
                            height="100%"
                            [useSrcset]="true"
                            [lazyLoad]="
                              'https://res.cloudinary.com/dmdawjgs8/image/upload/v1706597763/new/HandHeart_fz3k7l.webp'
                            "
                            defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                            alt="support-Icon"
                            class="ms-2 lazyImage"
                          />
                        </div>
                      } @else {
                        <div class="checkBox oHideBox dCenter">
                          <img
                            width="100%"
                            height="100%"
                            [useSrcset]="true"
                            [lazyLoad]="'assets/images/verify.svg'"
                            defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                            alt="Image-Icon"
                            class="ms-2 lazyImage"
                          />
                        </div>
                      }
                    </div>
                    <p class="gilroy-m long-text wow fadeInDown">
                      {{
                        expert?.shortBio ? expert?.shortBio : expert?.aboutMe
                      }}
                    </p>
                  </div>
                  <button
                    class="btn btn-outline-light book-now g-button position-absolute opacity0"
                  >
                    <span class="gilroy-m">View Profile</span>
                  </button>
                </div>
              </a>
            </div>
          }
        }
        @if (loading) {
          <div class="cstmCol overflow-hidden my-3">
            <div class="skeleton"></div>
          </div>
          <div class="cstmCol overflow-hidden my-3">
            <div class="skeleton"></div>
          </div>
          <div class="cstmCol overflow-hidden my-3">
            <div class="skeleton"></div>
          </div>
          <div class="cstmCol overflow-hidden my-3">
            <div class="skeleton"></div>
          </div>
          <div class="cstmCol overflow-hidden my-3">
            <div class="skeleton"></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
